<template>
  <div id="mb-quiz" class="mb-quiz">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <div v-if="gameState" class="curtain" @click="cancelCheck()"></div>
    <div class="mb-quiz-question" v-if="question" :style="[setQuestionStyle(question)]">
      <img v-if="question.img" :src="giveMeImagePlease(question.img.src)" />
    </div>
    <div class="mb-quiz-answers" :style="borderAnswerSetStyle(question)">
      <div
        class="mb-quiz-answer"
        v-for="(it, index) in items"
        :key="'mb-quiz-answer-' + index"
        :style="[
          { width: 100 / items.length + '%' },
          setAnswerStyle(),
          setAnswerPos(it.pos),
          setAnswerDimensions(it.width, it.height),
        ]"
      >
        <img
          draggable="false"
          :class="[{ 'mb-quiz-hover': startGameConfig.hoverItem }]"
          v-if="it.img"
          :src="giveMeImagePlease(it.img.src)"
          @click="setState(index)"
          :style="setImgMainStyle(it.width, it.height, it.state, checkImg, correctImg, inorrectImg)"
        />

        <div
          v-if="startGameConfig.checkbox"
          style="
            width: 60px;
            height: 60px;
            background: #f2f2f2;
            position: absolute;
            left: calc(50% - 30px);
            bottom: 20px;
            cursor: pointer;
            box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);
          "
        >
          <div
            @click="setState(index)"
            style="width: 46px; height: 46px; transition: 0.5s; margin: 7px; opacity: 0.8"
            :style="setDivStyle(it.state)"
          ></div>
        </div>
        <transition name="img-check-fade">
          <img
            draggable="false"
            v-if="it.state == 'check' && checkImg"
            :src="giveMeImagePlease(checkImg)"
            style="cursor: auto"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
        <transition name="img-fade">
          <img
            draggable="false"
            v-if="it.state == 'correct' && correctImg"
            :src="giveMeImagePlease(correctImg)"
            style="cursor: auto"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
        <transition name="img-fade">
          <img
            draggable="false"
            v-if="it.state == 'incorrect' && inorrectImg"
            :src="giveMeImagePlease(inorrectImg)"
            @click="setState(index)"
            :style="imgSetStyle(it.width, it.height)"
          />
        </transition>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-quiz',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      numberOfVerticalItems: 1,
      numberOfHorizontalItems: 1,
      question: '',
      items: [],
      checkImg: null,
      correctImg: null,
      inorrectImg: null,
      canIClick: true,
      gameState: false,
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    borderAnswerSetStyle(question) {
      let style = {};
      if (question && !this.startGameConfig.itemsPos) {
        style.height = '30%';
      } else {
        style.height = '100%';
        style.display = 'block';
        style.position = 'absolute';
        style.top = 0;
      }
      if (!question && this.startGameConfig.answerBox) {
        style.height = this.startGameConfig.answerBox.height + '%';
        style.width = this.startGameConfig.answerBox.width + '%';
        style.top = (100 - this.startGameConfig.answerBox.height) / 2 + '%';
        style.left = (100 - this.startGameConfig.answerBox.width) / 2 + '%';
      }
      return style;
    },
    setImgMainStyle(width, height, state, checkImg, correctImg, inorrectImg) {
      let style = {};
      if (width && height) {
        style.maxWidth = 'calc(100%)';
        style.maxHeight = 'calc(100%)';
      } else {
        style.maxWidth = 'calc(100% - 40px)';
        style.maxHeight = 'calc(100% - 40px)';
      }
      if (this.startGameConfig.checkbox) {
        style.maxHeight = 'calc(100% - 100px)';
      }
      if (state == 'check' && !checkImg) {
        style.filter =
          'drop-shadow(1px 1px 2px #648ad1) drop-shadow(1px -1px 2px #648ad1) drop-shadow(-1px -1px 2px #648ad1) drop-shadow(-1px 1px 2px #648ad1)';
        // style.borderRadius = '10px';
      } else if (state == 'correct' && !correctImg) {
        style.filter =
          'drop-shadow(1px 1px 2px #4f9149) drop-shadow(1px -1px 2px #4f9149) drop-shadow(-1px -1px 2px #4f9149) drop-shadow(-1px 1px 2px #4f9149)';
        // style.borderRadius = '10px';
      } else if (state == 'incorrect' && !inorrectImg) {
        style.filter =
          'drop-shadow(1px 1px 2px #990000) drop-shadow(1px -1px 2px #990000) drop-shadow(-1px -1px 2px #990000) drop-shadow(-1px 1px 2px #990000)';
        // style.borderRadius = '10px';
      }
      // if (this.startGameConfig.grid) {
      //   style.maxHeight = 'calc(100%)';
      //   style.maxWidth = 'calc(100%)';
      // }
      return style;
    },
    setDivStyle(state) {
      if (state == 'check') {
        return { background: '#0aabff' };
      } else if (state == 'correct') {
        return { background: '#00d60b' };
      } else if (state == 'incorrect') {
        return { background: '#fe0a02' };
      }
    },
    imgSetStyle(width, height) {
      if (width && height) {
        return { 'max-width': 'calc(100%)', 'max-height': 'calc(100%)' };
      } else {
        return { 'max-width': 'calc(100% - 40px)', 'max-height': 'calc(100% - 40px)' };
      }
    },
    setQuestionStyle(question) {
      let style;
      if (question) {
        if (question.width && question.height) {
          style = { width: question.width + 'px', height: question.height + 'px', position: 'absolute', padding: 0 };
          if (question.pos) {
            style.top = question.pos.y + 'px';
            style.left = question.pos.x + 'px';
          }
        }
        return style;
      }
    },
    setAnswerDimensions(w, h) {
      if (w && h) {
        return { width: w + 'px', height: h + 'px' };
      }
    },
    setAnswerPos(pos) {
      if (pos) {
        return { position: 'absolute', top: pos.y + 'px', left: pos.x + 'px' };
      }
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    checkGameCorrect() {
      let value = true;
      this.items.forEach((it) => {
        if (it.state == 'correct') {
          if (!it.correct) value = false;
        }
        if (it.state == 'incorrect') value = false;
        if (it.correct) {
          if (it.state != 'correct') value = false;
        }
      });
      this.gameState = value;
      console.log(value);
      if (this.gameState) {
        this.$store.dispatch('checkGame');
      }
    },
    setValue(items, id, it) {
      this.$set(items, id, it);
    },
    setState(id) {
      let it = this.items[id];
      if (it.state != 'correct') {
        if (this.canIClick) {
          this.canIClick = false;
          if (it.state) it.state = null;
          else it.state = 'check';
          this.setValue(this.items, id, it);
          if (it.state == 'check') {
            setTimeout(() => {
              if (it.correct) {
                this.startItemAudio(it);
                it.state = 'correct';
                this.setValue(this.items, id, it);
                this.checkGameCorrect();
              } else {
                this.startItemAudio(it);
                it.state = 'incorrect';
                this.setValue(this.items, id, it);
              }
              this.canIClick = true;
            }, 1000);
          } else {
            this.canIClick = true;
            this.checkGameCorrect();
          }
        }
      }
    },
    init() {
      this.numberOfVerticalItems = _.cloneDeep(this.startGameConfig.numberOfVerticalItems);
      this.numberOfHorizontalItems = _.cloneDeep(this.startGameConfig.numberOfHorizontalItems);
      this.question = _.cloneDeep(this.startGameConfig.question);
      if (this.startGameConfig.groups) {
        // this.startGameConfig.shuffle = false;
        this.startGameConfig.pick = false;
        let tmpArray = [];
        let tmpGroups = _.cloneDeep(this.startGameConfig.groups);
        if (this.startGameConfig.groupsShuffle) tmpGroups = this.shuffle(tmpGroups);
        for (let i = 0; i < tmpGroups.length; i++) {
          if (this.startGameConfig.shuffle) tmpGroups[i] = this.shuffle(tmpGroups[i]);
          tmpGroups[i].forEach((it) => {
            tmpArray.push(it);
          });
        }
        this.startGameConfig.items = tmpArray;
      }
      if (this.startGameConfig.pick) {
        let tmpArray = _.cloneDeep(this.startGameConfig.items);
        let tmpArrayIsAlways = [];
        let tmpArrayAdditional = [];
        tmpArray.forEach((el) => {
          if (el.isAlways) tmpArrayIsAlways.push(el);
          else tmpArrayAdditional.push(el);
        });
        tmpArray = tmpArrayIsAlways;
        tmpArrayAdditional = this.shuffle(tmpArrayAdditional);
        tmpArray = tmpArray.concat(tmpArrayAdditional.slice(0, this.startGameConfig.pick - tmpArray.length));
        this.items = _.cloneDeep(this.shuffle(tmpArray));
      } else {
        this.items = _.cloneDeep(this.startGameConfig.items);
        if (this.startGameConfig.shuffle) this.items = this.shuffle(this.items);
      }
      if (this.startGameConfig.itemsPos) {
        let posIndex = 0;
        this.items.forEach((el) => {
          if (!el.pos) {
            el.pos = this.startGameConfig.itemsPos[posIndex];
            posIndex++;
          }
        });
      }
      this.initAudio();
      this.checkImg = _.cloneDeep(this.startGameConfig.checkImg);
      this.correctImg = _.cloneDeep(this.startGameConfig.correctImg);
      this.inorrectImg = _.cloneDeep(this.startGameConfig.incorrectImg);
    },
    startItemAudio(audio) {
      if (audio.audio) {
        Howler.stop();
        audio.audio.play();
      }
    },
    initAudio() {
      this.items.forEach((el) => {
        if (el.audioSrc) {
          el.audio = new Howl({
            src: this.giveMeImagePlease(el.audioSrc),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
      });
    },
    setAnswerStyle() {
      return this.question
        ? { display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }
        : {
            width: 100 / this.numberOfHorizontalItems + '%',
            height: 100 / this.numberOfVerticalItems + '%',
            display: 'inline-block',
          };
    },
    cancelCheck() {
      // this.gameState = false;
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      console.log('CHECK');
      return this.gameState;
    },
    resetGameAction() {
      this.numberOfVerticalItems = 1;
      this.numberOfHorizontalItems = 1;
      this.question = '';
      this.items = [];
      this.checkImg = null;
      this.correctImg = null;
      this.inorrectImg = null;
      this.canIClick = true;
      this.gameState = false;
      this.init();
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 1
.mb-quiz
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .mb-quiz-question
    width: 100%
    padding: 50px
    height: 70%
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    img
      z-index: 2
      max-width: 100%
      max-height: 100%
  .mb-quiz-answers
    width: 100%
    height: 30%
    display: flex
    align-items: center
    flex-direction: row
    justify-content: space-evenly
    .mb-quiz-answer
      padding: 20px
      height: 100%
      // background-color: white
      position: relative
      img
        transition: .5s
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        cursor: pointer
        margin: auto
.mb-quiz-hover
  transition: .5s
  &:hover
    filter: drop-shadow(1px 1px 2px #648ad1)
.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
